<template>
  <v-app class="app-body">
    <div class="navinfo d-none d-md-block" v-if="mode === 'ats' || mode === 'atsDev'">
      <v-container>
        <v-row>
          <div class="ml-1">
            <v-icon color="white">mdi-map-marker</v-icon>
            <span class="ml-3 white--text caption">131 West 33rd St. unit 10D, New York NY-10001</span>
          </div>
          <div class="ml-5">
            <v-icon color="white">mdi-phone</v-icon>
            <span class="ml-3 white--text caption">1 (703) 839-3192</span>
          </div>
          <div class="ml-5">
            <v-icon color="white">mdi-email-open</v-icon>
            <span class="ml-3 white--text caption">support@atsfares.com</span>
          </div>
        </v-row>
      </v-container>
    </div>
    <navbar v-if="(mode !== 'ats' && mode !== 'atsDev') || ((mode === 'ats' || mode === 'adam' || mode === 'atsDev' || mode === 'adamDev') && $route.name !== 'login' && $route.name !== 'register' && $route.name !== 'verify' && $route.name !== 'resetPassword')"/>
    <v-main class="mt-15">
      <router-view></router-view>
    </v-main>
    <footerBar />
  </v-app>
</template>

<script>
import navbar from './components/navbar.vue'
import footerBar from './components/footer.vue'
import { profile, headersNoAuth, headers, homeTrips } from './links'
// import { db } from './firebase.js'

export default {
  name: 'App',
  components: {
    navbar,
    footerBar
  },
  data () {
    return {
      topWindow: 'hello',
      users: [],
      mode: 'fare',
      version: '2.1'
    }
  },
  // firebase: {
  //   users: db.ref('users/' + localStorage.getItem('userId')).orderByChild('createdAt')
  // },
  mounted () {
    if (this.$store.state.version !== this.version) {
      this.$store.dispatch('removeAirportsData')
      this.$store.dispatch('removeDatesData')
      this.$store.dispatch('removePassengersData')
      this.$store.dispatch('setPreferredAirline', null)
      this.$store.dispatch('setVersion', this.version)
    }
    // db.ref('users/' + localStorage.getItem('userId')).on('child_added', (snapshot) => {
    //   if (snapshot.val().read === 0) this.$store.state.newMail = true
    // })
    this.$store.dispatch('setUserMails', this.users)
    if (this.$cookies.isKey('userToken')) {
      let term = ''
      if (this.mode === 'ats' || this.mode === 'atsDev') term = '?host=ats'
      this.$http.get(profile(term), { headers: headers(this.$cookies.get('userToken')) }).then(response => {
        if (response.body.status) this.$store.dispatch('setUser', response.body.data)
        else {
          this.$store.dispatch('removeUser')
          this.$cookies.remove('userToken')
          localStorage.removeItem('userId')
          localStorage.removeItem('token')
        }
      })
    }
    // this.$http.get(getFlightPromotions, { headers: headersNoAuth() }).then(res => {
    //   this.$store.dispatch('setFlightPromotions', res.body.data)
    // })
    this.$http.get(homeTrips, { headers: headersNoAuth() }).then(response => {
      this.$store.dispatch('setHomeTrips', response.body.data)
    })
    if (!this.$store.state.countryCode) {
      this.$http.get('https://extreme-ip-lookup.com/json/').then(response => {
        this.$store.dispatch('setCountryCode', response.body.countryCode)
        response.body.operatingSystem = navigator.platform
        this.$store.dispatch('setGuestData', response.body)
        // this.$cookies.set('visitorData', response.body)
      })
    }
  },
  created () {
    this.mode = process.env.VUE_APP_MODE
    this.$store.dispatch('setMode', process.env.VUE_APP_MODE)
    if (this.mode === 'ats' || this.mode === 'atsDev') {
      if (localStorage.getItem('token')) this.$cookies.set('userToken', localStorage.getItem('token'), '1d')
    }
    if (((this.mode === 'ats' || this.mode === 'atsDev') && !this.$cookies.isKey('userToken')) ||
    ((this.mode === 'adam' || this.mode === 'adamDev') && !this.$cookies.isKey('userToken') &&
    this.$route.name !== 'terms' && this.$route.name !== 'privacy')) {
      if (this.$route.name !== 'login') this.$router.push({ name: 'login' })
    }
    window.addEventListener('beforeunload', (e) => {
      e.preventDefault()
      this.$store.dispatch('removeCountryCode')
      this.$store.dispatch('removeGuestData')
    })
  }
}
</script>

<style>
  .theme--light.v-application {
    background-color: #fff;
  }
  .navinfo {
    height: 50px;
    background-color: #1C2340;
    width: 100%;
  }
</style>
